/*
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-11-03 10:56:08
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-11-03 10:56:08
 */
import md5 from 'md5'

import request from '@/utils/request'
import { restData } from '@/config'

// token登录
export function appTokenLogin (params) {
  return request.post(restData.checkUserInfoUrl, params)
}

// session登录
export function appSessionLogin () {
  return request.get(restData.checkUserInfoUrl)
}

// 用于页面登录
export function pageLogin (params) {
  const {
    username,
    password,
    captcha,
  } = params

  return request.post(restData.checkLoginUrl, {
    captcha,
    username,
    password: params.md5 ? password : md5(password),
  })
}

// 用于其他系统登录
export function otherSystemLogin (params) {
  const {
    username,
    password,
    captcha,
    callbackUrl,
  } = params

  return request.post(restData.checkLoginUrl, {
    captcha,
    username,
    password: params.md5 ? password : md5(password),
    callbackUrl,
  })
}
// 用于页面注销
export function pageLogout () {
  return request.get(restData.logoutUrl)
}

export function getServiceAreaData (params) {
  return request.post('地址', params)
}
